import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { IconCheckmark, token, ListItem as ListItem$2 } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { ListContext } from './ListContext.js';

var StyledListItem = /*#__PURE__*/styled(ListItem$2).withConfig({
  componentId: "sc-szgmns-0"
})(["", " &::marker{color:", ";}&&&&{padding-top:0;}&:last-child{padding-bottom:0;}"], function (props) {
  return props.appearance === 'checkmark' ? "\n        position: relative;\n    " : '';
}, function (props) {
  return props.adornmentColor ? token("colors." + props.adornmentColor) : 'inherit';
});
var StyledIconCheckmark = /*#__PURE__*/styled(IconCheckmark).withConfig({
  componentId: "sc-szgmns-1"
})(["position:absolute;top:0;left:-", "px;color:", ";"], token('spacing.lg'), function (props) {
  return props.adornmentColor ? token("colors." + props.adornmentColor) : 'inherit';
});
var ListItem = function ListItem(props) {
  var _useContext = useContext(ListContext),
    appearance = _useContext.appearance,
    verticalSpace = _useContext.verticalSpace,
    adornmentColor = _useContext.adornmentColor;
  return /*#__PURE__*/React.createElement(StyledListItem, _extends({
    appearance: appearance,
    paddingBottom: verticalSpace,
    adornmentColor: adornmentColor
  }, props), appearance === 'checkmark' && /*#__PURE__*/React.createElement(StyledIconCheckmark, {
    size: "sm",
    adornmentColor: adornmentColor
  }), props.children);
};
ListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.shape({})
} : {};
var ListItem$1 = ListItem;

export { ListItem$1 as default };
